import PrincipalPageBanner from "./components/PrincipalPageBanner/PrincipalPageBanner";
import PrincipalPageDestinations from "./components/PrincipalPageDestinations/PrincipalPageDestinations";
import { lazy, Suspense, useEffect } from "react";
import LazyMount from "../../../../components/composed-styled-components/LazyMount/LazyMount";
import useDeviceType from "../../../../hooks/useDeviceType";
import { useLocation, useNavigate } from "react-router-dom";
import { usePrincipalPage } from "../../../../context/PrincipalPageContext/PrincipalPageContext";

const PrincipalPageImagesInfo = lazy(
  () => import("./components/PrincipalPageImagesInfo/PrincipalPageImagesInfo"),
);
const PrincipalPageVideo = lazy(
  () => import("./components/PrincipalPageVideo/PrincipalPageVideo"),
);
const sectionPlaceholder = (minHeight: number) => (
  <div aria-hidden="true" style={{ minHeight, background: "#ffffff" }} />
);

const VisitaxHome = () => {
  const { isMobile, isTablet } = useDeviceType();
  const location = useLocation();
  const navigate = useNavigate();
  const principalpageconfigs = usePrincipalPage();
  const videoPlaceholderHeight = isMobile ? 260 : isTablet ? 380 : 520;

  useEffect(() => {
    if (!location.state || typeof location.state !== "object") return;
    if (!("scrollToDestinations" in location.state) || !location.state.scrollToDestinations) return;

    let attempts = 0;
    const maxAttempts = 20;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (principalpageconfigs.destinosRef.current) {
        principalpageconfigs.scrollToSection(principalpageconfigs.destinosRef);
        window.clearInterval(timer);
        navigate(location.pathname, { replace: true, state: null });
      } else if (attempts >= maxAttempts) {
        window.clearInterval(timer);
        navigate(location.pathname, { replace: true, state: null });
      }
    }, 50);

    return () => {
      window.clearInterval(timer);
    };
  }, [location.pathname, location.state, navigate, principalpageconfigs]);

   return (<>
      <PrincipalPageBanner />
      {/* <LazyMount minHeight={560} placeholder={sectionPlaceholder(560)}>
        <Suspense fallback={sectionPlaceholder(560)}>
          <PrincipalPageCarousel />
        </Suspense>
      </LazyMount> */}

      <LazyMount placeholder={sectionPlaceholder(0)}>
        <Suspense fallback={sectionPlaceholder(0)}>
          <PrincipalPageImagesInfo />
        </Suspense>
      </LazyMount>

      <LazyMount minHeight={videoPlaceholderHeight} placeholder={sectionPlaceholder(videoPlaceholderHeight)}>
        <Suspense fallback={sectionPlaceholder(videoPlaceholderHeight)}>
          <PrincipalPageVideo />
        </Suspense>
      </LazyMount>

      {/* <LazyMount placeholder={sectionPlaceholder(0)}>
        <Suspense fallback={sectionPlaceholder(0)}>
          <PrincipalPageTestimonials />
        </Suspense>
      </LazyMount> */}

      <PrincipalPageDestinations />
   </>)
}
export default VisitaxHome;
